import {
  getCurrentProductFromUrl,
  getCurrentProductFilter,
  getFilterTypeFromPathname,
  getLessonsLink,
  filterK8Grades,
  sortGradesWithKFirst,
  createSchema,
  BaseValidator,
  getInitialSelectedSchool,
  checkBlockingValidations as sharedCheckBlockingValidations,
  checkLimitReached as sharedCheckLimitReached,
  getRelevantCourseList,
} from 'experienceComponents/CreateInstanceShared/dataUtils.js'

// Function to convert raw grade values to display values for classes
// Maps raw grades from userAccess (e.g., "K", "1", "2", "6", "7", "8") to display format
export const convertGradeToDisplayValue = gradeValue => {
  const normalizedGradeValue =
    typeof gradeValue === 'string' ? gradeValue.toLowerCase() : gradeValue

  // Handle single grade numbers (classes)
  if (normalizedGradeValue === 'k' || normalizedGradeValue === 'grade k') {
    return 'Grade K'
  }
  // Check if it's a single digit grade (1-8 for K-8)
  if (/^[1-8]$/.test(gradeValue)) {
    return `Grade ${gradeValue}`
  }
  // DWB high school grades (9-12)
  if (/^([9]|1[0-2])$/.test(gradeValue)) {
    return `Grade ${gradeValue}`
  }
  // Return as-is if already formatted or unknown format
  return gradeValue
}

// DO NOTE MOVE TO courseConfig.js. Moved this here to prevent circular dependency with that file
export const COURSE_CONFIG = {
  schemaName: 'CREATECOURSESCHEMA',
  requiresSite: true,
  requiresDates: false,
  filterFunction: 'filterK8Grades',
  sortFunction: 'sortGradesWithKFirst',
  getRelevantCourseList: courses => getRelevantCourseList(courses, false), // false = classes
  convertGradeToDisplayValue,
  duplicateMessage: 'You may not have a duplicate class name',
  validatorClass: 'CreateCourseValidator',
  validationType: 'course',
}

// Get program name from grade number
export const getProgramName = gradeNumber => {
  const gradeToProgramMap = {
    K: 'k5SelDigital',
    '1': 'k5SelDigital',
    '2': 'k5SelDigital',
    '3': 'k5SelDigital',
    '4': 'k5SelDigital',
    '5': 'k5SelDigital',
    '6': 'mspDigital',
    '7': 'mspDigital',
    '8': 'mspDigital',
    '9': 'highSchool',
    '10': 'highSchool',
    '11': 'highSchool',
    '12': 'highSchool',
  }
  return gradeToProgramMap[gradeNumber]
}

// Convert grade name to label
export const convertGradeNameToLabel = gradeName => {
  if (gradeName?.toLowerCase?.() === 'kindergarten') return 'K'

  const gradeLabel = gradeName?.split(' ')?.[1]
  return gradeLabel
}

/** Builds DWB LMS courseCode from a grade label (e.g. "5" -> "5_dwb_tier-1_siteEducator"). */
export const getDwbCourseCodeFromGradeLabel = gradeLabel => {
  if (!gradeLabel) return null
  return `${gradeLabel.toLowerCase()}_dwb_tier-1_siteEducator`
}

// Create view class behavior
export const createViewClassBehavior = (state, props) => {
  const currentProductName = getCurrentProductFromUrl(props.pathName)
    ?.productName
  const gradeLabel = convertGradeNameToLabel(state?.selectedGrade)
  const trimmedGradeName = gradeLabel ? gradeLabel.toLowerCase() : null
  const siteId = state?.selectedSchool?.siteId

  const destinationPath =
    currentProductName && state?.selectedCourse?.id && trimmedGradeName
      ? `/product/${currentProductName}/lessons/teach/grade-${trimmedGradeName}/unit-1?class=${state.selectedCourse.id}&site=${siteId}`
      : undefined

  props.redirectToMyClasses(destinationPath)
}

// Create component-specific schema
export const CREATECOURSESCHEMA = createSchema(COURSE_CONFIG)

// Create component-specific validator class
export class CreateCourseValidator extends BaseValidator {
  constructor(state, props) {
    super(state, props, COURSE_CONFIG)
  }
}

// Re-export shared functions for backward compatibility
export {
  getCurrentProductFromUrl,
  getCurrentProductFilter,
  getFilterTypeFromPathname,
  getLessonsLink,
  filterK8Grades,
  sortGradesWithKFirst,
  getInitialSelectedSchool,
}

// Component-specific wrapper functions
export const checkBlockingValidations = async (state, props) => {
  return sharedCheckBlockingValidations(state, props, COURSE_CONFIG)
}

export const checkLimitReached = (pathName, lms, maxClasses) => {
  return sharedCheckLimitReached(pathName, lms, maxClasses)
}
